export const findFunc = (arr, value, key) => arr?.find((i) => i[value]?.toLowerCase() === key?.toLowerCase())
export const dataSum = (dada) => dada ? dada.reduce((i, a) => i + a) : 0;
export const dataPercentValue = (data, sum) => data.map((i) => {
    const perctValue = (i / sum) * 100;
    return Math.round(perctValue);
  });